import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { ApiConfig ,API_CUSTOMER_ROUTER} from "../../../services/api-config";

export enum CustomerStatusCode {
  INACTIVE = 0,
  ACTIVE = 1,
}
export enum CustomerType {
  ENTERPRISE = 1, // Doanh nghiệp
  HOUSEHOLD = 2,  // Hộ gia đình
}
export interface Customer {
  id: number;
  code?: string | null;
  company_id: number;
  lead_id: string;
  total_spent: number;
  completed_orders: number;
  address: string;
  phone: string;
  name: string;
  status: CustomerStatusCode;
  created_at: string;
  updated_at: string;
  email?: string;
  type_customer: CustomerType;
  discount_percent: number;
  default_payment_method: number;
  requires_counting?: number;
  sale_id?: number | null;
  sale?: { id: number; name: string; phone?: string } | null;
  /** Chi nhánh mặc định của khách (BE trả kèm trong danh sách). */
  default_branch_id?: number;
  /** Toạ độ điểm giao nhận — null = chưa có. Dùng đối chiếu vị trí lúc hoàn thành đơn. */
  lat?: number | null;
  lng?: number | null;
  /** Nguồn toạ độ: 1=ghim tay, 2=geocode từ địa chỉ, 3=từ vị trí giao thực tế. */
  location_source?: number | null;
}

export interface CustomerListFilters {
  key_search?: string;
  page?: number;
  limit?: number;
  sort_by?: string;
  sort_order?: number;
  type_customer?: number; // optional filter by customer type
  status?: number; // 1=active, 0=inactive, -1=all
}


export type CustomerListApiResponse = {
  status: number;
  message?: string;
  data: {
    list: Customer[];
    total: number;
    page: number;
    limit: number;
  };
};

export interface CreateCustomerPayload {
  company_id: number;
  name: string;
  phone: string;
  address: string;
  type_customer?: CustomerType;
  email?: string;
  discount_percent?: number;
  default_payment_method?: number;
  requires_counting?: number;
  lat?: number | null;
  lng?: number | null;
}

export interface UpdateCustomerPayload {
  name?: string;
  phone?: string;
  address?: string;
  type_customer?: CustomerType;
  email?: string;
  discount_percent?: number;
  default_payment_method?: number;
  requires_counting?: number;
  /** Gửi null cả hai để XOÁ toạ độ; không gửi = giữ nguyên. */
  lat?: number | null;
  lng?: number | null;
}

export const CustomerService = {
  list: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<CustomerListApiResponse>({
        projectId: ApiConfig.PROJECT_ID.CUSTOMER_SERVICE,
      });

    return {
      fetch: (params: CustomerListFilters = {}) =>
        request({
          endPoint: API_CUSTOMER_ROUTER.API_LIST,
          data: {
            page: params.page ?? 1,
            limit: params.limit ?? 20,
            key_search: params.key_search ?? "",
            sort_by: params.sort_by ?? "created_at",
            sort_order: params.sort_order ?? 1,
            ...(params.type_customer ? { type_customer: params.type_customer } : {}),
            ...(params.status !== undefined && params.status !== null ? { status: params.status } : {}),
            company_id: 2000,
          },
        }),
      response: baseResponse,
      loading,
    };
  },

  countTabs: () => {
    const { request, baseResponse, loading } = useFetchData.Get<{
      total: number;
      total_active: number;
      total_inactive: number;
    }>({
      projectId: ApiConfig.PROJECT_ID.CUSTOMER_SERVICE,
    });
    return {
      fetch: (params: { key_search?: string; type_customer?: number } = {}) =>
        request({
          endPoint: API_CUSTOMER_ROUTER.API_COUNT_TABS,
          data: {
            key_search: params.key_search ?? "",
            ...(params.type_customer ? { type_customer: params.type_customer } : {}),
          },
        }),
      response: baseResponse,
      loading,
    };
  },

  create: () => {
    const { request, baseResponse, loading } =
      useFetchData.Post<BaseResponse<Customer>>({
        projectId: ApiConfig.PROJECT_ID.CUSTOMER_SERVICE,
      });

    return {
      fetch: (payload: CreateCustomerPayload) =>
        request({
          endPoint: API_CUSTOMER_ROUTER.API_CREATE,
          data: { ...payload, company_id: 2000,type_customer: payload.type_customer ?? CustomerType.ENTERPRISE},
        }),
      response: baseResponse,
      loading,
    };
  },

  update: () => {
    const { request, baseResponse, loading } =
      useFetchData.Post<BaseResponse<Customer>>({
        projectId: ApiConfig.PROJECT_ID.CUSTOMER_SERVICE,
      });

    return {
      fetch: (id: number, payload: UpdateCustomerPayload) =>
        request({
          endPoint: API_CUSTOMER_ROUTER.API_UPDATE(id),
          data: { ...payload, company_id: 2000,type_customer: payload.type_customer ?? CustomerType.ENTERPRISE, },
        }),
      response: baseResponse,
      loading,
    };
  },

  detail: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<BaseResponse<Customer>>({
        projectId: ApiConfig.PROJECT_ID.CUSTOMER_SERVICE,
      });

    return {
      fetch: (id: number) =>
        request({
          endPoint: API_CUSTOMER_ROUTER.API_DETAIL(id),
        }),
      response: baseResponse,
      loading,
    };
  },
};
